<template>
  <layout>
    <rdkm-title>
      {{ $t('Роли') }}
      <router-link tag="span" to="/roles/add">
        <b-button class="float-right" right size="sm" variant="primary">
          <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
        </b-button>
      </router-link>
    </rdkm-title>
    <div class="tile">
      <filter-form
        :group="query.group"
        v-on:search="$refs.grid.filter($event, true)"
      >
      </filter-form>
      <rdkm-grid ref="grid" :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="groupName" :title="$t('Тип организации')"></grid-column>
        <grid-column name="name" :title="$t('Роль')"></grid-column>
        <grid-column name="description" :title="$t('Описание')"></grid-column>
        <grid-column name="DELETE" cell="delete-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from '../../components/grid/Grid.vue';
import GridColumn from '../../components/grid/GridColumn.vue';
import FilterForm from './Filter';

export default {
  name: 'Roles',
  props: ['query'],
  components: {
    'rdkm-grid': Grid,
    'grid-column': GridColumn,
    'filter-form': FilterForm,
  },
};
</script>
